// require(["jquery"], function($){
document.addEventListener('DOMContentLoaded', function(event) {
function accord() {
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content1")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content1").slideUp(200);
      $(this)
        .siblings(".content1")
        .slideDown(200);
    }
  });
}
  setTimeout(accord, 10);
});